<template>
  <v-container>
    <v-card>

      <v-toolbar dark color="secondary">
        <v-autocomplete
          v-model="customer"
          :items="b2b.customers"
          label="Επιλογή Πελάτη"
          item-value="ID"
          clearable
          item-text="Name"
        ></v-autocomplete>
        <v-autocomplete
          v-model="offer"
          :items="b2b.offers"
          label="Επιλογή Προσφοράς"
          item-value="ID"
          clearable
          :item-text="(item)=>item.Title +' ID:'+item.ID "
        ></v-autocomplete>
        <v-select
          v-model="type"
          :items="types"
          label="Tύπος"
          item-value="type"
          clearable
          item-text="label"
        ></v-select>
        <v-btn class="primary" @click="filterLogs()"> Φιλτράρισμα</v-btn>
        <v-btn class="success" @click="clearFilter()"> Όλα</v-btn>
      </v-toolbar>
      <v-layout align-center justify-center>
        <v-flex xs12 sm10 md10>
          <log-items :logs="logs"></log-items>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import ApiData from "@/assets/ApiData";
import StoreState from "@/assets/StoreState";
import LogItems from "../components/LogItems";

export default {
  name: "Logs",
  components: {LogItems},
  data: () => ({
    types: [
      {type: 'order', label: 'Παραγγελία'},
      {type: 'login', label: 'Σύνδεση'}
    ],

    type: null,
    customer: null,
    offer: null,
    b2b: StoreState.b2b,
    store: StoreState,
    logs: [],
    logsCopy: []
  }),
  methods: {
    filterLogs() {
      let logs = JSON.parse(JSON.stringify(this.logsCopy));
      if (this.customer) {
        logs = logs.filter(item => item.CustomerID === this.customer);
      }
      if (this.offer) {
        logs = logs.filter(item => item.OfferID === this.offer);
      }
      if (this.type) {
        logs = logs.filter(item => item.Type === this.type);
      }
      this.logs = logs;
    },
    clearFilter() {
      this.customer = null;
      this.offer = null;
      this.logs = this.logsCopy;
      this.type = null
    }
  },
  mounted() {
    this.store.messages.isLoading = true;
    ApiData.getAllLogs().then(resp => {
      this.logs = resp.data.data;
      this.logsCopy = resp.data.data;
      this.store.messages.isLoading = false;
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Logs.vue